export default "<div class=\"flex column center fullWidth\">\n  <mat-spinner [diameter]=\"18\"></mat-spinner>\n</div>\n"